package fr.frux.shared.domain.model

/**
 * Replie les lettres accentuées sur leur base ASCII, en minuscules, pour comparer des noms
 * sans tenir compte des accents ni de la casse : « chataignier » doit trouver « Châtaignier ».
 * En Kotlin pur parce que `java.text.Normalizer` n'existe pas en commonMain.
 */
fun String.foldAccents(): String =
    buildString(length) {
        for (char in this@foldAccents.lowercase()) {
            append(FOLDED[char] ?: char)
        }
    }

/** Vrai si [query] apparaît dans la chaîne, accents et casse ignorés. */
fun String.containsFolded(query: String): Boolean = foldAccents().contains(query.foldAccents())

private val FOLDED: Map<Char, Char> =
    buildMap {
        fun fold(
            base: Char,
            accented: String,
        ) = accented.forEach { put(it, base) }
        fold('a', "àáâãäåāăą")
        fold('c', "çćĉċč")
        fold('e', "èéêëēĕėęě")
        fold('i', "ìíîïĩīĭįı")
        fold('n', "ñńņň")
        fold('o', "òóôõöøōŏő")
        fold('u', "ùúûüũūŭůűų")
        fold('y', "ýÿŷ")
        fold('s', "śŝşš")
        fold('z', "źżž")
        fold('g', "ĝğġģ")
        fold('l', "ĺļľł")
        fold('r', "ŕŗř")
        fold('t', "ţťŧ")
        fold('d', "ďđ")
    }
